import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { initDb } from './lib/db';
import AdminLayout from './layouts/AdminLayout';
import Login from './pages/auth/Login';
import ReviewPage from './pages/public/ReviewPage';
import Dashboard from './pages/admin/Dashboard';
import Reviews from './pages/admin/Reviews';
import Locations from './pages/admin/Locations';
import Settings from './pages/admin/Settings';
import SuperAdminDashboard from './pages/superadmin/Dashboard';
import Businesses from './pages/superadmin/Businesses';
import SmtpSettings from './pages/superadmin/SmtpSettings';
import SiteSettings from './pages/superadmin/SiteSettings';
import Users from './pages/superadmin/Users';
import EmailTemplates from './pages/superadmin/EmailTemplates';
import SuperAdminLocations from './pages/superadmin/Locations';
import AdminFAQ from './pages/admin/FAQ';
import SuperAdminFAQ from './pages/superadmin/FAQ';

const RootRedirect = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Login />;
  return <Navigate to={user.role === 'superadmin' ? '/superadmin' : '/admin'} replace />;
};

function App() {
  useEffect(() => {
    initDb();
    document.title = 'SocialCard Review';
  }, []);

  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<RootRedirect />} />

            {/* Nyilvános értékelő oldal */}
            <Route path="/r/:slug" element={<ReviewPage />} />

            {/* Admin felület */}
            <Route path="/admin" element={<AdminLayout requiredRole="admin" />}>
              <Route index element={<Dashboard />} />
              <Route path="locations" element={<Locations />} />
              <Route path="reviews" element={<Reviews />} />
              <Route path="faq" element={<AdminFAQ />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            {/* Superadmin felület */}
            <Route path="/superadmin" element={<AdminLayout requiredRole="superadmin" />}>
              <Route index element={<SuperAdminDashboard />} />
              <Route path="businesses" element={<Businesses />} />
              <Route path="locations" element={<SuperAdminLocations />} />
              <Route path="users" element={<Users />} />
              <Route path="smtp" element={<SmtpSettings />} />
              <Route path="settings" element={<SiteSettings />} />
              <Route path="email-templates" element={<EmailTemplates />} />
              <Route path="faq" element={<SuperAdminFAQ />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
